import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxpc3RhbmJ1bCUyMHNreWxpbmUlMjBidXNpbmVzc3xlbnwwfHx8fDE3ODEzODYzMzB8MA&ixlib=rb-4.1.0&q=85";

export default function Hero({ onPrimary, onSecondary }) {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative pt-32 md:pt-40 pb-24 md:pb-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="lg:col-span-7"
          >
            <div className="flex items-center gap-3 mb-8">
              <span className="gold-divider" />
              <span className="overline">Altin Link Ltd. Şti.</span>
            </div>

            <h1
              data-testid="hero-title"
              className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-altin-ink"
            >
              Delivering Strategic{" "}
              <br />
              Commercial{" "}
              <span className="italic text-altin-gold">Partnerships</span>{" "}
              Across Global Markets.
            </h1>

            <p
              data-testid="hero-subtitle"
              className="mt-8 text-lg md:text-xl text-altin-muted font-light leading-relaxed max-w-xl"
            >
              Altin Link helps manufacturers, suppliers, distributors,
              investors and corporate buyers connect, negotiate and grow
              through trusted international business relationships.
            </p>

            <p className="mt-4 text-sm uppercase tracking-[0.22em] text-altin-muted">
              Türkiye · Europe · Middle East · Global
            </p>

            <div className="mt-12 flex flex-wrap items-center gap-4">
              <button
                data-testid="hero-contact-btn"
                onClick={onPrimary}
                className="group inline-flex items-center gap-3 bg-altin-ink text-white px-8 py-4 text-xs tracking-[0.22em] uppercase hover:bg-altin-gold transition-colors duration-300"
              >
                Schedule a Consultation
                <ArrowRight
                  weight="light"
                  className="transition-transform group-hover:translate-x-1"
                />
              </button>
              <button
                data-testid="hero-consultation-btn"
                onClick={onSecondary}
                className="group inline-flex items-center gap-3 border border-altin-gold text-altin-ink px-8 py-4 text-xs tracking-[0.22em] uppercase hover:bg-altin-gold hover:text-white transition-colors duration-300"
              >
                Start Your Business Journey
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.2, ease: "easeOut" }}
            className="lg:col-span-5 relative"
          >
            <div className="relative">
              <div className="absolute -bottom-6 -left-6 w-full h-full bg-altin-surfaceAlt -z-10" />
              <div className="relative overflow-hidden">
                <img
                  src={HERO_IMG}
                  alt="Istanbul skyline at dusk"
                  className="w-full h-[480px] md:h-[560px] object-cover"
                  loading="eager"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-altin-ink/30 via-transparent to-transparent" />
                <div className="absolute bottom-6 left-6 right-6 backdrop-blur-md bg-white/70 border border-white/40 p-5">
                  <p className="text-[11px] uppercase tracking-[0.25em] text-altin-gold">
                    Headquartered in
                  </p>
                  <p className="font-serif-display text-2xl text-altin-ink mt-1">
                    Istanbul, Türkiye
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-px bg-altin-border border border-altin-border">
          {[
            { k: "Markets", v: "20+" },
            { k: "Industries", v: "10" },
            { k: "Partners", v: "Trusted" },
            { k: "Reach", v: "Global" },
          ].map((s) => (
            <div
              key={s.k}
              data-testid={`hero-stat-${s.k.toLowerCase()}`}
              className="bg-altin-bg px-6 py-8 text-center"
            >
              <div className="font-serif-display text-4xl text-altin-ink">
                {s.v}
              </div>
              <div className="mt-2 text-[11px] uppercase tracking-[0.25em] text-altin-muted">
                {s.k}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
